import type { SpecialKey } from '@/types/rune'
import type { UserAttrType } from '@/types/user'
import type { DarkGoldAttrType, GetDarkGoldFactorRes } from '@/types/equip'
import { useUserStore } from '@/stores/modules/user'
import { equipAffixCollection } from './affix'
import { formatNumber } from '@/utils'

export let darkGoldBasicFactor: Partial<UserAttrType> = {}
export let darkGoldSpecialFactor: Partial<Record<SpecialKey, any>> = {}
export function setdarkGoldFactor(res: GetDarkGoldFactorRes) {
  darkGoldBasicFactor = res.darkGoldBasicFactor
  darkGoldSpecialFactor = res.darkGoldSpecialFactor
}

 const refineHitFactor: Record<number, number> = {
  0: 1,
  1: 1.3,
  2: 1.8,
  3: 2.4,
}
export function getDarkGoldBasicAttrValue(key: keyof UserAttrType, value: number, hitCount: number) {
  if (value === 15) value += 2
  // @ts-ignore
  const res = darkGoldBasicFactor[key]! * value * refineHitFactor[hitCount]
  if (['crt', 'crtd', 'hr', 'atksp', 'ad'].includes(key)) return res.toFixed(1)
  return Math.round(res)
}
export function explainDarkGoldEquipAffix(affixList: { key: SpecialKey; data: any }[], showExtra: boolean = true) {
  const userStore = useUserStore()
  const extraAttrs = showExtra ? userStore.getExtraAttrs : {}
  return affixList.map((item) => {
    const { key, data } = item
    const equipAffix = equipAffixCollection[key]
    const name = equipAffixCollection[key].name
    const affixData = getRealAffixData(key, data)
    const desc = equipAffix.desc({ ...affixData, ...extraAttrs[key], soulType: userStore.soulType })
    const specKeyList = Object.keys(darkGoldSpecialFactor[key])
    const percent = (data[specKeyList[0]] || data[specKeyList[1]]) * 10
    return `${
      data.value === 10 || data.multiplier === 10 || data.rate === 10 ? '<span>★</span> ' : ''
    }<span class="special">${name}</span>（<span class="darkGold">${formatNumber(percent, 2)}%</span>）：${desc}`
  })
}
// 获取刻印属性的加成key值
export function getEngraveDataKey(special: DarkGoldAttrType['special']) {
  if (!special || special.length === 0) return ''
  const specKey = special[0].key
  const dataKeyList = Object.keys(special[0].data)
  if (dataKeyList.length === 1) {
    return dataKeyList[0]
  } else if (dataKeyList.length === 2) {
    // 过滤出用于加成的key
    return Object.keys(darkGoldSpecialFactor[specKey]).filter((value) => dataKeyList.includes(value))[0]
  }
}
function getRealAffixData(key: SpecialKey, data: any) {
  const factor = darkGoldSpecialFactor[key]
  const res = { ...data }
  Object.keys(res).forEach((item: string) => {
    if (factor[item]) {
      res[item] = (res[item] + 10) * factor[item]
      if (key === 'swiftness') res[item] += 1
    }
  })
  return res
}
